/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, forwardRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Logout from "src/assets/images/log-out.svg";
import logOutBlack from "src/assets/images/logOutBlack.svg";
import SigmaLogo from "src/assets/images/S1GMA_Logo.svg"
import { isSignoutModalOpen } from "src/thunks/auth";
import ProjectManagerMenu from "./projectManagerMenu";
import DepotManagerMenu from "./depotManagerMenu";
import moment from "moment";
import Menu from "./menu";

const SideBar = forwardRef((props, ref) => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();
  const [t, I18n] = useTranslation();
  const navigate = useNavigate();

  /** hooks useState ----------------------------------------------------- **/
  const [isShown, setIsShown] = useState(false)

  /** Variable declarations ------------------------------ **/
  const loginTime = localStorage.getItem("loginTime")
  const diffMilliseconds = moment().diff(moment(loginTime));
  const duration = moment.duration(diffMilliseconds);
  const hours = Math.abs(duration.hours());
  const minutes = Math.abs(duration.minutes());
  const userData = JSON.parse(localStorage.getItem("userDetails"))
  const popupRef = useRef()
  const lastName = userData?.lastName.charAt(0);
  const firstName = userData?.firstName.charAt(0);

  const handleCloseButtonClick = () => {
    setIsShown(!isShown)
  }

  /** hooks useEffect----------------------------------------------------- **/
  useEffect(() => {
    dispatch(isSignoutModalOpen(isShown))
  }, [isShown])

  /** handler functions--------------------------------------------------- **/

  /** Function executes when logout user -------------------- **/
  const logoutUser = () => {

    localStorage.removeItem("userDetails");
    localStorage.removeItem("loginTime")
    localStorage.removeItem("email");
    localStorage.removeItem("filterAllData");
    localStorage.removeItem("searchValue");
    navigate("/login");
    window.location.reload()
  }

  /** Function to handle image error ------------------ **/
  const imgError = (image) => {
    image.onerror = "";
    image.src = "https://img.freepik.com/free-icon/user_318-563642.jpg";
    return true;
  }

  /* Close Sidebar Navigation on Mobile View */
  const closeMstBurger = () => {
    var menuPanel = document.getElementById('menuCollapseset');
    menuPanel.classList.remove("open");
  }

  /* Close Sidebar if it's open (on click hide it) */
  const closeSidebarOnClick = () => {
    var menuPanel = document.getElementById('menuCollapseset');
    if (menuPanel.classList.contains("open")) {
      menuPanel.classList.remove("open");
    }
  }
  return (
    <>
      <div ref={ref} className="dashboard-nav" id="menuCollapseset" style={{ position: "relative" }}>
        <header>
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <img
                src={userData?.profileUrl || "https://img.freepik.com/free-icon/user_318-563642.jpg"}
                onError={imgError}
                alt="Avatar" className="avatar"
              />
              <span style={{ color: "black", fontSize: 14, paddingLeft: 12, fontFamily: "Montserrat-bold" }}>
                {firstName || ""}{lastName || ""}
              </span>

            </div>
            <button type="button" class="btn-close btn-close-black d-block d-lg-none" aria-label="Close" id="close-mstBurger" onClick={closeMstBurger}></button>
          </div>

        </header>
        <nav className="dashboard-nav-list" style={{ overflowX: "scroll", height: "65%" }}>
          {userData?.roles == "ProjectManager" ?
            ProjectManagerMenu.map((item, index) => {
              return (
                <NavLink className="listItem dashboard-nav-item" onClick={closeSidebarOnClick} key={index} to={item.path} aria-current="page" style={{ borderBottom: "1px solid lightblue" }} >
                  {t(item.label)}
                </NavLink>
              );
            })
            : userData?.roles == "DepotManager" ?
              DepotManagerMenu.map((item, index) => {
                return (
                  <NavLink key={index} to={item.path} aria-current="page" className={"dashboard-nav-item"} style={{ borderBottom: "1px solid lightblue" }} >
                    {t(item.label)}
                  </NavLink>
                );
              }) :

              Menu.map((item, index) => {
                return (
                  <NavLink key={index} to={item.path} aria-current="page" className={"dashboard-nav-item"} style={{ borderBottom: "1px solid lightblue" }} >
                    {t(item.label)}
                  </NavLink>
                );
              })}
        </nav>
        <div style={{ width: "100%", paddingTop: 10 }}>
          <div style={{ paddingLeft: 22, paddingRight: 12 }} >
            <div style={{ color: "black", paddingBottom: 8, fontSize: 11, fontWeight: 100 }} onClick={() => handleCloseButtonClick()}>
              <img src={Logout} alt="Avatar" style={{ width: 15, height: 15, marginLeft: -12, marginRight: 8, color: 'black' }} />
              <span style={{ cursor: 'pointer' }} >SIGN-OUT</span>

              <div className={`popup-menu ${isShown ? 'shown' : ''}`} ref={popupRef} >
                <div style={{ height: "35px", width: "90px" }}>
                  <img width={"100%"} height={"100%"} src={SigmaLogo} alt="muz image" />
                </div>
                <div className="d-flex flex-column align-items-start mt-5" style={{ display: "flex", alignItems: 'center' }}>
                  <img
                    src={userData?.profileUrl || "https://img.freepik.com/free-icon/user_318-563642.jpg"}
                    onError={imgError}

                    alt="Avatar" className="signout-image-style" />
                  <span className="login-user-name-signout-text-style">{userData?.firstName} {userData?.lastName}</span>
                </div>
                <div className="d-flex flex-column mt-5">
                  <span className="signed-in-since-text-style">Signed in since:</span>
                  <span className="date-signput-text-style text-uppercase">{moment(loginTime).format("DD-MMM-YYYY")}</span>
                  <span className="date-signput-text-style">{moment(loginTime).format("hh:mm")}</span>
                  <span className="time-style-for-signout">{hours} h {minutes} m</span>

                </div>
                <div className="add-m-top-for-signout">
                  <p className="text-style-logout" style={{ lineHeight: 1 }}>Are you sure you want to sign-out?</p>
                  <div style={{ position: "relative", display: "flex", alignItems: "center", marginTop: 40 }}>
                    <span className="signout-no-text-style"  >NO </span>
                    <button className="yes-signout-button-style" style={{ height: 40, position: "absolute", right: -35, width: 85, background: "#e94f37", textAlign: "start" }} onClick={logoutUser}>
                      YES
                      <img src={logOutBlack} alt="Avatar" style={{ width: 15, height: 15, marginLeft: 10 }} />
                    </button>

                  </div>
                  <div className="d-flex justify-content-end">
                    <i className="bi bi-caret-right-fill fold-button-styling-for-signout-yes"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex flex-lg-column" style={{ marginLeft: 10, fontSize: 8, fontFamily: "Montserrat-Regular", marginTop: 13, color: "black" }}>
          <span>© {moment().year()} &nbsp;</span>
          <span> Muztrans Transport</span>
          <span> & Logistics Ltd</span>
        </div>
      </div>
    </>
  );
});

export default SideBar;
